import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "泄漏电流、大气腐蚀数据展示系统", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.bgCSS)
  }, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_ctx.showLogoutLink ? (_openBlock(), _createBlock(_component_el_link, {
        key: 0,
        onClick: _ctx.logout,
        style: {
          "float": "right"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("登出")]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _hoisted_1]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        width: "300px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tree, {
          "node-key": "id",
          data: _ctx.leftTree,
          props: _ctx.defaultProps,
          onNodeClick: _ctx.handleNodeClick
        }, null, 8, ["data", "props", "onNodeClick"])]),
        _: 1
      }), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })], 4);
}